import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { StaticUrls, Profilo, ModificaPasswordReset } from '../models';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class ResetPasswordService {
  private headers = new Headers({ 'Content-Type': 'application/json' });
  private options = new RequestOptions({ headers: this.headers });

  private headersText = new Headers({ 'Content-Type': 'text/plain' });
  private optionsText = new RequestOptions({ headers: this.headersText });

	constructor(private http: Http) { }

  sendRequest(profilo: Profilo): Observable<Response>
  {
    return this.http.post(StaticUrls._richiesta_reset_pass, JSON.stringify(profilo), this.options)
      .map( response => 
      {
        return response;
      });
  }

  checkToken(token: string): Observable<Response>
  {
    return this.http.post(StaticUrls._check_reset_token, token, this.optionsText)
      .map( response => 
      {
        return response;
      });
  }

  updatePassword(modificaPasswordReset: ModificaPasswordReset): Observable<Response>
  {
    return this.http.post(StaticUrls._update_password, JSON.stringify(modificaPasswordReset), this.options)
      .map( response => 
      {
        return response;
      });
  }
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/reset-password.service.ts